import type { RouteRecordRaw } from 'vue-router';

export const DATA_EXPORT_ROUTE_NAME = 'data-export';

export const dataExportRoutes = [
  {
    path: 'data-export',
    name: DATA_EXPORT_ROUTE_NAME,
    component: () => import('./DataExportPage.vue'),
    meta: { title: 'Data Export' },
  },
] as const satisfies readonly RouteRecordRaw[];
